import React from 'react';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TripMatch, TripRequest } from '@marageti/z4-sdk/lib/travel';
import { TravelerProfile } from '@marageti/z4-sdk/lib/people';
import TripRequestMessageSidebarView from './trip-request-message-sidebar-view';
import TripMatchMessageSidebarView from './trip-match-message-sidebar-view';
import { useAuthStore } from '../../../store';
import useTravelerTicketsCount from '../../../hooks/use-traveler-tickets-count';

type MessageSidebarContainerProps = {
  variant: 'tripMatch' | 'tripRequest';
  tripMatchId?: string;
  tripRequestId?: string;
};

const MessageSidebarContainer = ({
  variant = 'tripRequest',
  tripMatchId,
  tripRequestId,
}: MessageSidebarContainerProps) => {
  const apiClient = useApiClient();
  const tripMatch = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const tripRequest = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripRequestId || tripMatch.data?.tripRequestId], !!tripRequestId || !!tripMatch.data?.tripRequestId);
  const tripRequestTripMatches = useFetch<TripMatch[]>(apiClient.tripRequestsClient.getTripRequestTripMatches, [tripRequestId], !!tripRequestId);
  const travelerId = (tripMatch.data || tripRequest.data)?.travelers[0].id;
  const travelerProfile = useFetch<TravelerProfile>(apiClient.peopleClient.getTravelerProfile, [travelerId], !!travelerId);
  const { loggedInTeamMember } = useAuthStore();
  const { mutate: refetchTicketCount } = useTravelerTicketsCount(travelerId);

  const handleEdit = () => {
    travelerProfile.mutate();
    tripMatch.mutate();
    tripRequest.mutate();
  };

  const error = tripMatch.error || tripRequest.error || travelerProfile.error;
  const travelers = tripMatch.data?.travelers || tripRequest.data?.travelers;

  if (variant === 'tripMatch') {
    return (
      <TripMatchMessageSidebarView
        error={error}
        travelers={travelers}
        travelerId={travelerId}
        tripMatch={tripMatch.data}
        tripRequest={tripRequest.data}
        onEditSuccess={handleEdit}
      />
    );
  }

  return (
    <TripRequestMessageSidebarView
      error={error}
      loggedInTeamMember={loggedInTeamMember}
      travelers={travelers}
      travelerId={travelerId}
      tripRequest={tripRequest.data}
      tripRequestTripMatches={tripRequestTripMatches.data}
      onEditSuccess={handleEdit}
      refetchTicketCount={refetchTicketCount}
    />
  );
};

export default MessageSidebarContainer;
